import api from 'features/common/transport'
import { ERROR_DEFAULT } from 'features/common/core/errors'
import { z } from 'zod'

const employeeQRResponseSchema = z.object({ member_card: z.string() })

const getEmployeeQR = async ({
    qrId,
    name,
    role,
    language,
}: {
    qrId: number
    name: string
    role: string
    language: string
}) => {
    const res = await api.get(
        `qrs/members/${language}/${qrId}?name=${encodeURIComponent(name)}&role=${role}`,
    )
    const parseRes = employeeQRResponseSchema.safeParse(await res.json())

    if (parseRes.success) {
        return parseRes.data.member_card
    }
    throw new Error(ERROR_DEFAULT + ' ' + res.statusText)
}

export default getEmployeeQR
